export const getDefaultErrorMessage = () => {
    return {
        Title: 'Det har skjedd en teknisk feil.',
        Body: 'Prøv igjen senere.',
    };
};
export const getErrorMessage = (response) => {
    return response?.ErrorMessage || getDefaultErrorMessage();
};
